// extracted by mini-css-extract-plugin
module.exports = {"languageSkills":"LanguageSkills_languageSkills__2ncca","buttonsContainer":"LanguageSkills_buttonsContainer__2lXmi","button":"LanguageSkills_button__3P2fB"};